/* ------------------------------------------------------------------
 * PROCESS REPORT BUTTON  v5.1  –  Kompakt akış, eksiksiz analiz
 * ------------------------------------------------------------------ */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// PDF kenar boşlukları
const ML = 40, MT = 40, LINE_H = 16;

const cloneWithCanvas = (orig) => {
  const clone = orig.cloneNode(true);
  const srcCanvases = orig.querySelectorAll('canvas');
  const dstCanvases = clone.querySelectorAll('canvas');
  srcCanvases.forEach((src, i) => {
    const dst = dstCanvases[i];
    dst.width = src.width;
    dst.height = src.height;
    dst.getContext('2d', { willReadFrequently: true }).drawImage(src, 0, 0);
  });
  return clone;
};

function FloatingPdfBtn() {
  const makePdf = async () => {
    // 1) Grafik Getir sayfasında mıyız?
    if (document.querySelector('.section h2')?.textContent.trim() !== 'Grafik Getir') {
      return alert('Lütfen önce “Grafik Getir” sayfasına gidip grafiği oluşturun.');
    }

    // 2) Meta bilgileri oku
    const meta = {};
    document.querySelectorAll('.section p').forEach(p => {
      const t = p.textContent;
      if (t.startsWith('Konu:'))     meta.subject     = t.replace('Konu:', '').trim();
      if (t.startsWith('Açıklama:')) meta.description = t.replace('Açıklama:', '').trim();
      if (t.startsWith('Birim:'))    meta.unit        = t.replace('Birim:', '').trim();
      if (t.startsWith('LSL:'))      meta.limits      = t.replace(/LSL:|USL:/g, m => m==='LSL:'?'':'/').trim();
      if (t.startsWith('Sahibi'))    meta.owner       = t.replace('Sahibi (owner):', '').trim();
    });

    // 3) jsPDF setup
    const pdf   = new jsPDF({ unit: 'pt', format: 'a4' });
    const pW    = pdf.internal.pageSize.getWidth();
    const pH    = pdf.internal.pageSize.getHeight();
    const contentW = pW - ML * 2;
    const contentH = pH - MT * 2;

    // Kapak
    pdf.setFont('helvetica','bold').setFontSize(18)
       .text('PROCESS CONTROL REPORT', pW/2, MT, { align:'center' });
    pdf.setFont('helvetica','normal').setFontSize(10)
       .text(`Generated: ${new Date().toLocaleString()}`, pW/2, MT+16, { align:'center' });
    pdf.setFontSize(12);
    let cursorY = MT+48;
    const drawMeta = (label, val) => {
      if (!val) return;
      pdf.text(`${label}:`, ML, cursorY);
      pdf.text(val, ML+100, cursorY);
      cursorY += LINE_H;
    };
    drawMeta('Subject',     meta.subject);
    drawMeta('Description', meta.description);
    drawMeta('Unit',        meta.unit);
    drawMeta('LSL / USL',   meta.limits);
    drawMeta('Owner',       meta.owner);

    // Footer helper
    const addFooter = (num, total) => {
      pdf.setFontSize(9)
         .text(`Page ${num} / ${total}`, pW/2, pH - 20, { align:'center' });
    };

    // 4) Grafik bloklarını topla
    const charts = [...document.querySelectorAll('.chart-container')];
    if (!charts.length) {
      alert('Grafik bulunamadı!');
      return;
    }

    // Yeni içerik sayfası
    pdf.addPage();
    let pageNum = pdf.internal.getNumberOfPages();
    let yOffset = 0;

    for (const chart of charts) {
      // wrapper: grafik + proses yeterlilik + AI analizi
      const wrapper = document.createElement('div');
      wrapper.style.background = '#fff';
      wrapper.appendChild(cloneWithCanvas(chart));

      // Proses Yeterlilik
      let sib = chart.nextElementSibling;
      while (sib && !sib.querySelector('h4')) sib = sib.nextElementSibling;
      if (sib?.querySelector('h4')?.textContent.includes('Proses')) {
        wrapper.appendChild(cloneWithCanvas(sib));
      }

      // Grafik AI Analizi
      const aiDiv = chart.parentElement.querySelector('h4')?.parentElement;
      if (aiDiv?.querySelector('h4')?.textContent.includes('Grafik AI')) {
        wrapper.appendChild(cloneWithCanvas(aiDiv));
      }

      // screenshot
      document.body.appendChild(wrapper);
      const canvas = await html2canvas(wrapper, { scale:2, useCORS:true });
      document.body.removeChild(wrapper);

      const imgH = canvas.height * (contentW / canvas.width);
      const imgData = canvas.toDataURL('image/png');

      // Blokları sayfaya doldur
      let drawn = 0;
      while (drawn < imgH) {
        const space = contentH - yOffset;
        const drawH  = Math.min(space, imgH - drawn);
        pdf.addImage(
          imgData, 'PNG',
          ML, MT + yOffset,
          contentW, imgH,
          undefined, 'FAST',
          0, drawn / imgH
        );
        drawn  += drawH;
        yOffset += drawH;
        if (drawn < imgH) {
          addFooter(pageNum, '');
          pdf.addPage();
          pageNum = pdf.internal.getNumberOfPages();
          yOffset = 0;
        }
      }

      // Blok sonuna küçük boşluk
      const gap = 12;
      if (yOffset + gap > contentH) {
        addFooter(pageNum, '');
        pdf.addPage();
        pageNum++;
        yOffset = 0;
      } else {
        yOffset += gap;
      }
    }

    // 5) Footer'ları güncelle
    const total = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= total; i++) {
      pdf.setPage(i);
      addFooter(i, total);
    }

    pdf.save('process-report.pdf');
  };

  return (
    <button className="pdf-floating-btn" title="PDF indir" onClick={makePdf}>
      📄
    </button>
  );
}

// Portal: App.js'e dokunmadan ekle
export default function AutoMountPdfButton() {
  useEffect(() => {
    const host = document.createElement('div');
    document.body.appendChild(host);
    ReactDOM.render(<FloatingPdfBtn />, host);
    return () => {
      ReactDOM.unmountComponentAtNode(host);
      document.body.removeChild(host);
    };
  }, []);
  return null;
}

// Named export, App.js import hatasını çözmek için
export const ProcessReportButton = FloatingPdfBtn;
